import React, { useState } from 'react';

interface Props {
  title: string;
  children: React.ReactNode[];
  collapse?: boolean;
  showEmpty?: boolean;
}

const CollapsiblePanel = (props: Props) => {
  const { title, children, showEmpty = true } = props;
  const [isCollapsed, setCollapsed] = useState(true);

  const togglePanel = () => {
    setCollapsed(!isCollapsed);
  };

  const rotationStyle = isCollapsed ? { transform: '' } : { transform: 'rotate(90deg)' };

  if (!showEmpty && children.filter((c) => c !== undefined).length < 1) {
    return;
  }
  return (
    <div id='containers-collapsible-wrapper' className={`rounded-md transition-all duration-500`}>
      <div
        id='containers-collapsible-container'
        className="flex items-center justify-between cursor-pointer"
        onClick={togglePanel}
      >
        <div id={`containers-collapsible-${title}`} className="text-lg">{title}</div>
        <div id={`containers-collapsible-button`}  className={`duration-150 w-fit`} style={rotationStyle}>
          &#9654;
        </div>
      </div>
      <div id={`containers-collapsible-panel`}  className={`pl-2 panel-content ${isCollapsed ? 'hidden' : 'block'} mt-2`}>
        {children}
      </div>
    </div>
  );
};

export default CollapsiblePanel;
